import { Dto } from '@core/data/dto/dto';
import { DtoForceConstructor, DtoImport, DtoExport } from '@core/utils/dto';
import { ChildSupportSchema } from './child-support.schema';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';
import { DtoType } from '@core/data/dto/dto-types';
import { Moment } from 'moment';

@DtoForceConstructor
export class ChildSupport implements Dto {

    public id: string;
    public agency: string;
    public amount: number;
    public externalId: string;
    public fipsCode: string;
    public maxPercent: number;
    public issueDate: Moment;
    public managed: boolean;

    @DtoImport(ChildSupportSchema)
    static import(dto: Dto): ChildSupport {
        return new ChildSupport(dto);
    }

    constructor(value?: any) {
        if (value) {
            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: ChildSupportSchema,
        },
    ])
    export(type?: DtoType): any {}  
}
